// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"4":"8797ab18","182":"5774ad97","212":"43f5af3a","474":"3f233b08","483":"b6c401a6","618":"b7c9f911","630":"3a5a8404","701":"3e6e67cc","760":"c9258642"}[chunkId] + ".chunk.js";
};